import styled from 'styled-components'

export const StyledTitle = styled.span`
  display: flex;
  gap: var(--bq-spacing-xs);
  align-items: center;
`

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--bq-spacing-l);
`

export const StyledSectionItem = styled(StyledSection)`
  gap: var(--bq-spacing-xs);
`

export const StyledSectionItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--bq-spacing-xs);
`
